import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Command,
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { canAccessModule } from "@/lib/permissions";
import { ADMIN_NAVIGATION } from "@/lib/adminNavigation";
import { Users } from "lucide-react";

export default function CommandPalette({ open, onOpenChange }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [clients, setClients] = useState([]);
  const pages = ADMIN_NAVIGATION.filter(
    (page) => canAccessModule(user, page.module) && (!page.adminOnly || user?.role === "admin"),
  );

  useEffect(() => {
    const handler = () => onOpenChange(true);
    window.addEventListener("pleiades:open-cmd", handler);
    return () => window.removeEventListener("pleiades:open-cmd", handler);
  }, [onOpenChange]);

  useEffect(() => {
    if (!open) return;
    api.get("/clients").then((r) => setClients(r.data.slice(0, 20))).catch(() => {});
  }, [open]);

  const go = (path) => {
    onOpenChange(false);
    navigate(path);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Danışan ara veya sayfaya git…" data-testid="cmd-input" />
      <CommandList>
        <CommandEmpty>Sonuç bulunamadı.</CommandEmpty>
        <CommandGroup heading="Sayfalar">
          {pages.map((p) => {
            const Icon = p.icon;
            return (
              <CommandItem
                key={p.to}
                onSelect={() => go(p.to)}
                data-testid={`cmd-page-${p.to}`}
              >
                <Icon className="w-4 h-4 mr-2" />
                {p.label}
              </CommandItem>
            );
          })}
        </CommandGroup>
        {clients.length > 0 && (
          <CommandGroup heading="Danışanlar">
            {clients.map((c) => (
              <CommandItem
                key={c.id}
                onSelect={() => go(`/danisanlar/${c.id}`)}
                data-testid={`cmd-client-${c.id}`}
              >
                <Users className="w-4 h-4 mr-2" />
                <span className="flex-1">{c.full_name}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
